"use strict";

exports.__esModule = true;
exports.Grid = void 0;

var _styled = require("@manifest-ui/styled");

var _grid = require("./utils/grid");

const props = new Set(['columns', 'columnWidth']);
const Grid = (0, _styled.styled)('div', {
  label: 'Grid',
  themeKey: 'grid',
  shouldForwardProp: prop => (0, _styled.shouldForwardProp)(prop) && !props.has(prop)
})(({
  columns,
  columnWidth
}) => ({
  boxSizing: 'border-box',
  display: 'grid',
  gap: 2,
  gridTemplateColumns: columnWidth ? (0, _grid.widthToColumns)(columnWidth) : (0, _grid.countToColumns)(columns)
}));
exports.Grid = Grid;
Grid.displayName = 'Grid';